var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',[_c('q-card',[_c('q-card-section',[_c('logo'),_c('div',{staticClass:"text-h5"},[_vm._v("Не удалось оплатить счёт №"+_vm._s(_vm.$route.query.BillNumber))]),_c('div',{staticClass:"text-h6 text-right"},[_vm._v(_vm._s(_vm.dateConverter(_vm.$route.query.BillDate)))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }